import React from "react";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import { RootState } from "../../redux/store";

function PrivateRoute({ children, ...rest }: any) {
  const isAuthenticated = useSelector(
    (state: RootState) => state.user.isAuthenticated
  );

  if (!isAuthenticated) {
    return (
      <Redirect to={{ pathname: "/login", state: { from: window.location.pathname } }} />
    );
  }

  return <Route {...rest}>{children}</Route>;
}

export default PrivateRoute;
